import { useServiceWorker } from '../hooks/useServiceWorker';

export function UpdatePrompt() {
  const { updateAvailable, updateApp } = useServiceWorker();

  const handleUpdate = () => {
    updateApp();
  };

  if (!updateAvailable) return null;

  return (
    <div className="fixed top-20 left-1/2 -translate-x-1/2 z-50 animate-slide-down">
      <div className="bg-blue-600 text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-4">
        <span className="text-sm">🔄 Update beschikbaar</span>
        <button
          onClick={handleUpdate}
          className="bg-white text-blue-600 px-4 py-2 rounded-sm text-sm font-bold hover:bg-blue-50 active:bg-blue-100"
        >
          Nu updaten
        </button>
      </div>
    </div>
  );
}
